import React, { useState } from 'react';
import { Col, Row, Text } from 'react-quick-style-components';
import { useNavFunc } from 'navigation';
import { COLOR } from 'const';

export interface ISubItem {
  title: string;
  screen: string;
  params?: any;
}

export interface INavItemProps {
  title: string;
  screen: string;
  params?: any;
  subItems?: ISubItem[];
  fontSize?: number;
  marginLeft?: number | string;
  [anyProp: string]: any;
}

const NavItem = (props: INavItemProps) => {
  const { title, screen, params, subItems, fontSize, marginLeft, ...restProps } = props;
  const { navigate } = useNavFunc();
  const [showDropdown, setShowDropdown] = useState<boolean>(false);
  
  const MENU_FONT_SIZE = fontSize || 14;
  const hasSubItems = subItems && subItems.length > 0;

  const handlePress = () => {
    navigate(screen, params);
    if (hasSubItems) {
      setShowDropdown(false);
    }
  };

  return (
    <Col 
      marginLeft={marginLeft || 20}
      style={{ position: 'relative' }}
      onMouseEnter={() => hasSubItems && setShowDropdown(true)}
      onMouseLeave={() => hasSubItems && setShowDropdown(false)}
      {...restProps}
    >
      <Col middle onPress={handlePress}>
        <Text colorWhite fontSize={MENU_FONT_SIZE} bold>{title}</Text>
      </Col>
      {hasSubItems && showDropdown && (
        <Col
          absolute
          top="100%"
          left={0}
          paddingTop={8}
          backgroundColor="black"
          paddingVertical8
          minWidth={180}
          borderRadius={4}
          style={{
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
            zIndex: 1000,
          }}
        >
          {subItems.map((subItem, index) => (
            <Row
              key={`subitem-${index}`}
              paddingVertical12
              paddingHorizontal16
              onPress={() => {
                navigate(subItem.screen, subItem.params);
                setShowDropdown(false);
              }}
              onHoverStyle={{ backgroundColor: 'rgba(255,255,255,0.1)' }}
            >
              <Text fontSize={MENU_FONT_SIZE - 2} colorWhite>{subItem.title}</Text>
            </Row>
          ))}
        </Col>
      )}
    </Col>
  );
};

export default NavItem;

